<mat-drawer-container (backdropClick)="backDropClicked()" class="interaction-bar-container" fullscreen>
  <mat-drawer
    [disableClose]="disableClose"
    #drawer
    (closedStart)="clearActiveBtn()"
    class="interaction-bar"
    [ngClass]="{
      wider: widerPages.has(drawerState) || manualWideness.value === INTERACTION_BAR_WIDENESS.WIDER,
      slightlyWider:
        slightlyWiderPages.has(drawerState) || manualWideness.value === INTERACTION_BAR_WIDENESS.SLIGHTLY_WIDER,
    }"
    mode="over"
    [position]="drawerState | handleInteractionBarPosition"
  >
    @if (drawer.opened) {
      @switch (drawerState) {
        @case (INTERACTION_BAR_STATES.ROLLUP_INTERACTION_BAR) {
          @if (user.data$ | async) {
            <app-rollups-interaction-bar></app-rollups-interaction-bar>
          }
        }
        @case (INTERACTION_BAR_STATES.LINE_ITEMS_SPEND_SUMMARY) {
          <app-line-item-spend-summary></app-line-item-spend-summary>
        }
        @case (INTERACTION_BAR_STATES.MESSAGES) {
          @if (user.data$ | async) {
            <app-messages-wrapper [drawerState]="drawerState" [data]="drawerData"></app-messages-wrapper>
          }
        }
        @case (INTERACTION_BAR_STATES.NOTIFICATIONS) {
          @if (user.data$ | async) {
            <app-notifications></app-notifications>
          }
        }
        @case (INTERACTION_BAR_STATES.TEAM_MANAGEMENT) {
          <app-manage-team-members-sidebar></app-manage-team-members-sidebar>
        }
        @case (INTERACTION_BAR_STATES.TEAM_PROP_PROJ_LIST) {
          <app-shared-team-prop-proj-sidebar [data]="drawerData"></app-shared-team-prop-proj-sidebar>
        }
        @case (INTERACTION_BAR_STATES.SIDEBAR_PC_TO_CONTRACT) {
          <app-pc-to-contract-sidebar></app-pc-to-contract-sidebar>
        }
        @case (INTERACTION_BAR_STATES.SIDEBAR_ADD_CONTRACT) {
          <app-contract-sidebar></app-contract-sidebar>
        }
        @case (INTERACTION_BAR_STATES.SIDEBAR_CHANGE_ORDER) {
          <app-change-order-sidebar></app-change-order-sidebar>
        }
        @case (INTERACTION_BAR_STATES.SIDEBAR_INVOICE) {
          <app-invoice-sidebar></app-invoice-sidebar>
        }
        @case (INTERACTION_BAR_STATES.SIDEBAR_MISC_COST) {
          <app-misc-cost-sidebar></app-misc-cost-sidebar>
        }
        @case (INTERACTION_BAR_STATES.SIDEBAR_SUBMITTAL_PACKAGE) {
          <app-submittal-package-sidebar
            [packageId]="drawerData?.packageId"
            [selectedRegistries]="drawerData?.selectedRegistries"
          ></app-submittal-package-sidebar>
        }
        @case (INTERACTION_BAR_STATES.SIDEBAR_SUBMITTAL_ENTRY) {
          <app-submittal-entry-sidebar></app-submittal-entry-sidebar>
        }
        @case (INTERACTION_BAR_STATES.PROJECT_PROGRESS) {
          <app-track-item-sidebar></app-track-item-sidebar>
        }
        @case (INTERACTION_BAR_STATES.ACTIVITY_SIDEBAR) {
          <app-activity-sidebar></app-activity-sidebar>
        }
        @case (INTERACTION_BAR_STATES.PRIME_CONTRACT) {
          <app-prime-contract-sidebar [projectId]="drawerData?.id" [isEdit]="drawerData?.isEdit">
          </app-prime-contract-sidebar>
        }
        @case (INTERACTION_BAR_STATES.PRIME_CHANGE_ORDER) {
          <app-prime-contract-change-order-sidebar></app-prime-contract-change-order-sidebar>
        }
        @case (INTERACTION_BAR_STATES.CHANGE_ACTION) {
          <app-change-action-sidebar [data]="drawerData"></app-change-action-sidebar>
        }
        @case (INTERACTION_BAR_STATES.PCO_DETAILS_SIDEBAR) {
          <app-pco-details [PCOLog]="drawerData?.data"></app-pco-details>
        }
        @case (INTERACTION_BAR_STATES.COR_DETAILS_SIDEBAR) {
          <app-cor-details [CORLogItem]="drawerData?.data"></app-cor-details>
        }
        @case (INTERACTION_BAR_STATES.PRIME_INVOICE) {
          <app-prime-invoice-sidebar [isEdit]="drawerData?.isEdit" [invoiceId]="drawerData?.invoiceId">
          </app-prime-invoice-sidebar>
        }
        @case (INTERACTION_BAR_STATES.ANTICIPATED_INCOME) {
          <app-anticipated-income-sidebar></app-anticipated-income-sidebar>
        }
        @case (INTERACTION_BAR_STATES.SETUP_PROJECT_MANAGER) {
          <app-project-setup-manager
            [isEdit]="drawerData?.isEdit"
            [isInvitationAccept]="drawerData?.isInvitationAccept"
          >
          </app-project-setup-manager>
        }
        @case (INTERACTION_BAR_STATES.SETUP_PROJECT_GC) {
          <app-project-setup-gc
            [isEdit]="drawerData?.isEdit"
            [isInvitationAccept]="drawerData?.isInvitationAccept"
          ></app-project-setup-gc>
        }
        @case (INTERACTION_BAR_STATES.REPORTING) {
          <app-bar-reporting [data]="drawerData"></app-bar-reporting>
        }
        @case (INTERACTION_BAR_STATES.REPORTING_INVOICE_PANEL) {
          <app-invoice-report-panel [data]="drawerData"></app-invoice-report-panel>
        }
        @case (INTERACTION_BAR_STATES.ADD_PROPERTY) {
          <app-add-property [data]="drawerData"></app-add-property>
        }
        @case (INTERACTION_BAR_STATES.EDIT_PROPERTY) {
          <app-add-property [data]="drawerData"></app-add-property>
        }
        @case (INTERACTION_BAR_STATES.BUDGET_ADJUSTMENT) {
          <app-budget-adjustment-sidebar></app-budget-adjustment-sidebar>
        }
        @case (INTERACTION_BAR_STATES.BUDGET_ADJUSTMENT_LOG) {
          <app-budget-adjustment-log [adjustments]="drawerData"></app-budget-adjustment-log>
        }
        @case (INTERACTION_BAR_STATES.FORECAST_MODIFICATIONS) {
          <app-forecast-modifications-sidebar></app-forecast-modifications-sidebar>
        }
        @case (INTERACTION_BAR_STATES.FILE_SHARE) {
          <app-share-document [data]="drawerData"></app-share-document>
        }
        @case (INTERACTION_BAR_STATES.DOCUMENTS_LINK_SHARE) {
          <app-share-document-link [data]="drawerData"></app-share-document-link>
        }
        @case (INTERACTION_BAR_STATES.MANAGE_PROJECT) {
          <app-manage-project></app-manage-project>
        }
        @case (INTERACTION_BAR_STATES.CREATE_RFI) {
          <app-create-rfi [rfi]="drawerData?.rfi"></app-create-rfi>
        }
        @case (INTERACTION_BAR_STATES.RFI_DETAILS) {
          <app-rfi-details-sidebar [rfiId]="drawerData?.rfiId"></app-rfi-details-sidebar>
        }
        @case (INTERACTION_BAR_STATES.CONTACT_SIDEBAR) {
          <app-contact-sidebar
            [contact]="drawerData?.contact"
            [contactGroup]="drawerData?.contactGroup"
          ></app-contact-sidebar>
        }
        @case (INTERACTION_BAR_STATES.INVITES_SIDEBAR) {
          <app-invites-sidebar
            [markAsSubmitted]="drawerData?.fillFields"
            [projectId]="drawerData?.projectId"
            [contactId]="drawerData?.contactId"
            [inviteFor]="drawerData?.inviteFor"
          ></app-invites-sidebar>
        }
        @case (INTERACTION_BAR_STATES.SUBMITTAL_PACKAGE_DETAILS) {
          <app-submittal-package-details-sidebar [packageId]="drawerData?.id"></app-submittal-package-details-sidebar>
        }
      }
    }
  </mat-drawer>

  <ng-content></ng-content>
</mat-drawer-container>
